module.exports = __webpack_public_path__ + "img/new16.084c1135.jpg";